import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsStackItemProps, SettingsStackItems, SettingsTemplate} from '@dms/settings/shared';

import {buildArray} from 'shared/web';

import {BranchPreselectionSection} from '../../components/BranchPreselectionSection/BranchPreselectionSection';
import {MaximumAcceptedPriceSection} from './MaximumAcceptedPriceSection';

export function BusinessCases() {
  const items = buildArray<SettingsStackItemProps>()
    .add({
      cyId: testIds.settings.businessCase('definition-link'),
      title: i18n.t('page.salesSettingsBusinessCase.labels.businessCaseDefinition'),
      url: settingsRoutes.businessCaseDefinition,
    })
    .add({
      cyId: testIds.settings.businessCase('comissionFee-link'),
      title: i18n.t('page.salesSettingsBusinessCase.labels.commissionFeeTitle'),
      url: settingsRoutes.businessCaseCommissionFee,
    })
    .whenFeatureEnabled(featureFlags.SALES_CENTRALIZED_PRICING, {
      cyId: testIds.settings.businessCase('centralizedPricing-link'),
      title: i18n.t('page.salesSettingsBusinessCase.labels.centralizedPricing'),
      url: settingsRoutes.businessCaseCentralizedPricing,
    })
    .add({
      cyId: 'generatedDocuments',
      title: i18n.t('page.bcDocumentsSettings.labels.title'),
      url: settingsRoutes.generatedDocuments,
    })
    .add({
      cyId: 'dueDates',
      title: i18n.t('page.settings.labels.dueDates'),
      url: settingsRoutes.businessCaseDueDates,
    })
    .whenFeatureEnabled(featureFlags.OFFER_VALIDITY, {
      cyId: testIds.settings.businessCaseOfferValidity('link'),
      title: i18n.t('page.settings.labels.offerValidity'),
      url: settingsRoutes.businessCaseOfferValidity,
    });

  return (
    <SettingsTemplate
      header={{title: i18n.t('page.businessCases.title')}}
      data-testid="settings-businessCases"
    >
      <MaximumAcceptedPriceSection />
      <BranchPreselectionSection
        recordType="business-case"
        label={i18n.t('page.salesSettings.branchPreselection.businessCaseLabel')}
        data-testid={testIds.settings.businessCase('branchPreselection')}
      />
      <SettingsStackItems items={items} />
    </SettingsTemplate>
  );
}
